module.exports = __webpack_public_path__ + "static/media/Web.bf817eff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logos/Web.jpg
// module id = 1006
// module chunks = 0